<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center column class="error-style">
        <v-flex class="display-4">
          4<v-icon>face</v-icon>4
        </v-flex>
        <v-flex class="headline">Ups...?</v-flex>
        <v-flex class="subheading">Strona nie istnieje.</v-flex>
        <v-flex class="pt-3">
          <v-btn flat color="accent" to="/" router v-if="isMain">Idź do strony głównej</v-btn>
          <v-btn flat color="accent" to="/login" router v-if="!isMain">Idź do strony logowania</v-btn>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: { isMain: Boolean }
}
</script>

<style scoped>
i {
  font-size: 70px;
  color: inherit !important;
}
.error-style {
  color: #26A69A;
}
.flex {
  flex-grow: 0
}
</style>
